import React, { useState } from 'react';
import { Screen } from '../types';

const MyPermitsScreen = ({ navigateTo }) => {
  const [activeTab, setActiveTab] = useState('Active');

  const activePermits = [
    { id: 'ILP-8839202', title: 'Tawang District Entry', validity: 'Oct 10 - Oct 25, 2023', img: 'https://picsum.photos/seed/tawangmap/400/200' },
    { id: 'ILP-9928312', title: 'West Kameng Entry', validity: 'Nov 01 - Nov 15, 2023', img: 'https://picsum.photos/seed/kamengmap/400/200' }
  ];

  const expiredPermits = [
    { id: 'ILP-1120021', title: 'Itanagar Capital Complex', date: 'Sept 01, 2023', img: 'https://picsum.photos/seed/itanagarmap/400/200?grayscale' },
    { id: 'ILP-3349102', title: 'Ziro Valley Festival', date: 'Aug 15, 2023', img: 'https://picsum.photos/seed/ziromap/400/200?grayscale' }
  ];

  return (
    <div className="ilp-screen gray-bg">
      <div className="ilp-header white-bg">
        <button className="ilp-back-btn" onClick={() => navigateTo(Screen.Home)}>
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M15 19l-7-7 7-7" />
          </svg>
        </button>
        <h2>My Permits</h2>
        <div className="ilp-user-avatar">
          <svg width="24" height="24" viewBox="0 0 20 20" fill="#9ca3af">
            <path fillRule="evenodd" d="M10 9a3 3 0 100-6 3 3 0 000 6zm-7 9a7 7 0 1114 0H3z" clipRule="evenodd" />
          </svg>
        </div>
      </div>

      <div className="ilp-tabs white-bg">
        <div className="ilp-tabs-inner">
          <button 
            className={`ilp-tab ${activeTab === 'Active' ? 'active' : ''}`}
            onClick={() => setActiveTab('Active')}
          >
            Active
          </button>
          <button 
            className={`ilp-tab ${activeTab === 'History' ? 'active' : ''}`}
            onClick={() => setActiveTab('History')}
          >
            History
          </button>
        </div>
      </div>

      <div className="ilp-permits-content">
        {activeTab === 'Active' ? (
          <div className="ilp-permits-list">
            {activePermits.map((permit) => (
              <div key={permit.id} className="ilp-permit-item">
                <div className="ilp-permit-item-header">
                  <div className="ilp-permit-item-info">
                    <div className="ilp-status-badge active">
                      <div className="ilp-status-dot"></div>
                      <span>Active</span>
                    </div>
                    <span className="ilp-permit-id">{permit.id}</span>
                  </div>
                  <h3>{permit.title}</h3>
                  <div className="ilp-permit-validity">
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                      <path d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
                    </svg>
                    <span>Valid: {permit.validity}</span>
                  </div>
                  <button className="ilp-view-details">
                    <span>View Details</span>
                    <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                      <path d="M9 5l7 7-7 7" />
                    </svg>
                  </button>
                </div>
                <div className="ilp-permit-item-image">
                  <img src={permit.img} alt={permit.title} crossOrigin="anonymous" />
                  <div className="ilp-image-overlay"></div>
                </div>
              </div>
            ))}

            <div className="ilp-section-divider">
              <span>Recently Expired</span>
            </div>

            {expiredPermits.map((permit) => (
              <div key={permit.id} className="ilp-permit-item expired">
                <div className="ilp-permit-item-header">
                  <div className="ilp-permit-item-info">
                    <div className="ilp-status-badge expired">
                      <div className="ilp-status-dot"></div>
                      <span>Expired</span>
                    </div>
                    <span className="ilp-permit-id">{permit.id}</span>
                  </div>
                  <h3>{permit.title}</h3>
                  <div className="ilp-permit-validity">
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                      <path d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
                    </svg>
                    <span>Expired on {permit.date}</span>
                  </div>
                  <button className="ilp-view-details">
                    <span>View Receipt</span>
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                      <path d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                    </svg>
                  </button>
                </div>
                <div className="ilp-permit-item-image">
                  <img src={permit.img} alt={permit.title} crossOrigin="anonymous" />
                </div>
              </div>
            ))}
          </div>
        ) : (
          <div className="ilp-empty-state">
            <div className="ilp-empty-icon">
              <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="#cbd5e1" strokeWidth="2">
                <path d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
              </svg>
            </div>
            <p>No historical permits found.</p>
          </div>
        )}
      </div>

      <div className="ilp-floating-btn">
        <button className="ilp-primary-btn" onClick={() => navigateTo(Screen.Consent)}>
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3">
            <path d="M12 6v6m0 0v6m0-6h6m-6 0H6" />
          </svg>
          <span>New Permit</span>
        </button>
      </div>
    </div>
  );
};

export default MyPermitsScreen;

